export const CHAINES_LOCALES_RECUES = 'Chaîne(s) locale(s) reçue(s)';



// WEBPACK FOOTER //
// ./src/utils/constantes.util.js